import { safeContinuePath } from './safeContinuePath';

/**
 * Central platform admins skip Central's own onboarding (owner rule,
 * 2026-10-07). Whether THIS user is one is decided by the server from the
 * database flag (`GET /api/onboarding/exempt`) — never from anything held in
 * the browser. Any failure answers "not exempt": the ordinary flow runs.
 */
export async function fetchOnboardingExempt(): Promise<boolean> {
  try {
    const res = await fetch('/api/onboarding/exempt', { credentials: 'include' });
    if (!res.ok) return false;
    const data = await res.json().catch(() => null);
    return data?.ok === true && data.exempt === true;
  } catch {
    return false;
  }
}

/**
 * Where an exempt user goes instead of onboarding: the app sign-in they came
 * with (a validated `/api/…` continuation, e.g. /api/oidc/authorize) is
 * completed with a full navigation; anything else lands on the Central
 * dashboard. Onboarding continuations are not followed — that is the point.
 */
export function leaveOnboarding(
  continueUrl: string,
  navigate: (to: string, opts?: { replace?: boolean }) => void,
): void {
  const safe = safeContinuePath(continueUrl);
  if (safe && safe.startsWith('/api/')) {
    window.location.href = safe;
    return;
  }
  navigate('/home', { replace: true });
}
